import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import NextApp from './NextApp';
import * as registerServiceWorker from './registerServiceWorker';

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <NextApp />
    </AppContainer>,
    document.getElementById('root'),
  );
};

// Render once
render();

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render();
  });
}

// Do this once
registerServiceWorker.unregister();
